/** Bildirishnoma o'ng tugma menyusi: o'qilgan/o'qilmaganiga va havolasiga qarab (test: menu.test.ts). */
import { Check, CheckCheck, Copy, ExternalLink, Eye, MailOpen } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";
import type { Notification } from "./api";

export interface NotificationMenuActions {
  open: () => void;
  openNewTab: () => void;
  markRead: () => void;
  markUnread: () => void;
  markAllRead: () => void;
  copy: (text: string) => void;
}

export function notificationMenu(n: Notification, a: NotificationMenuActions, t: Translate): MenuEntry[] {
  const unread = !n.read_at;
  return compactMenu([
    !!n.link && { key: "open", label: t("open"), icon: Eye, onSelect: a.open },
    !!n.link && { key: "open-tab", label: t("openNewTab"), icon: ExternalLink, onSelect: a.openNewTab },
    SEPARATOR,
    unread && { key: "read", label: t("notification.markRead"), icon: Check, onSelect: a.markRead },
    !unread && { key: "unread", label: t("notification.markUnread"), icon: MailOpen, onSelect: a.markUnread },
    { key: "read-all", label: t("notification.markAllRead"), icon: CheckCheck, onSelect: a.markAllRead },
    SEPARATOR,
    { key: "copy", label: t("notification.copyText"), icon: Copy, onSelect: () => a.copy([n.title, n.body].filter(Boolean).join("\n")) },
  ]);
}
